export const addAddressQuestions: Record<string, any> = {
  postcode: {
    labelKey: 'applicationForm.ADD_ADDRESS.postcode.label',
  },
  address1: {
    labelKey: 'applicationForm.ADD_ADDRESS.address1.label',
  },
  address2: {
    labelKey: 'applicationForm.ADD_ADDRESS.address2.label',
  },
  city: {
    labelKey: 'applicationForm.ADD_ADDRESS.city.label',
  },
  country: {
    labelKey: 'applicationForm.ADD_ADDRESS.country.label',
  },
  fullAddress: {
    labelKey: 'applicationForm.ADD_ADDRESS.fullAddress.label',
  },
  whenMoveDate: {
    labelKey: 'applicationForm.ADD_ADDRESS.whenMove.label',
  },
};
